module.exports = __webpack_public_path__ + "imgs/refresh-icon.svg";